import React, {Component} from 'react'
import { Waypoint } from 'react-waypoint'

import Player from '../Player/Player'
import Expander from '../Expander/Expander'

import Lock from '../Lock/Lock'

import './styles.scss'

class ChapterSix extends Component {
    constructor(props) {
        super(props);
        this.state = { width: 0, height: 0 };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }
        
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }
        
    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }
    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }
    render () {
        return (
            <>
                <Waypoint horizontal onEnter={()=>{this.props.chapterTransition("six")}}> 
                    <div className="chapter chapter-six chapter-6" style={{height: this.state.height + "px" }}>
                        <div className="scroll-container bg">
                            <div className="scroll"></div>
                        </div>
                        <div className="scroll-container one">
                            <div className="white-content scroll">
                                <h2>Skolopenderen er et glupsk og skummelt rovdyr med kraftige kjever, som kan bite skikkelig fra seg.</h2>
                                <p>Skolopenderen har mange føtter, litt som et kravlende tusenbein, men på de fremste føttene har den skarpe klør og giftige tenner. Klørne og tennene gjør at den kan holde fast og forgifte byttene sine.</p>
                            </div>
                            <Player file='6_1' />
                        </div>
                        <div className="scroll-container two">
                            <div className="scroll">
                                <h2>Den gode nyheten er at skolopenderen er på størrelse med en binders og bare spiser små insekter, sånn som det stakkars, snåle skrukketrollet.</h2>
                                <p>Puh! Tenk om den hadde vært på størrelse med en bjørn, da hadde vi sluttet å gå tur i skogen. Da måtte vi heller løpt tur der! </p>
                            </div>
                            <Player file='6_2' />
                        </div>
                        <div className="scroll-container three">
                            <div className="white-content scroll">
                                <h2>En stokk er mer enn noe du kan hvile eller balansere på.</h2>
                                <p>Stokken er hjemmet til ekstremt mange kryp, planter, moser, lav og sopp – til og med en sopp som ser ut som sjokolade (sjokoladekjuke). Derfor er det viktig at du alltid rydder opp etter deg når du er i skogen. Rull stokken tilbake og plasser de store barkebitene over stubben igjen. Da har du forstyrret festen lenge nok. På tide å la skolopenderen og skrukketrollet rocke videre, sammen med alle de andre krypene!</p>
                            </div>
                            <Player file='6_3' />
                        </div>
                        <div className="scroll-container four">
                            <div>
                                <h2>Her bor:</h2>
                                <p>Skolopenderen, skrukketrollet og furupraktbilla</p>
                            </div>
                            <Player file='6_4' />
                        </div>
                        <div className="thank-you">Takk for at du skyller, bretter og stapper skolemelka for skolopenderen!</div>
                        <Expander
                            class="expander-one"
                            content="Skolopenderen jakter på natta. Noen ganger forviller den seg inn i husene våre, særlig når det er høst eller vår. Uæ!"
                            chapter="6"
                        ></Expander>
                        <Lock 
                            progress="outro"
                            text="Slutten på skogen" 
                            classes="button"
                            handleModal={this.props.handleModal}
                            >
                        </Lock>
                    </div>
                </Waypoint>
            </>
        )
    }
}
export default ChapterSix